export enum OutputFormat {
  Png = 'png',
  Webp = 'webp',
  Jpeg = 'jpeg',
}
